import { DataCache, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { PersonProfilePageResponse } from 'data/models/PersonProfilePageResponse';

export class PersonProfilePageCache extends DataCache {
    PersonProfilePageResponses = PCCollection(PersonProfilePageResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship   (this.PersonProfilePageResponses, data.PCUsers,       r => r.PCUser, null);
        new QueryResultsRelationship(this.PersonProfilePageResponses, data.PCUsers,       r => r.InvitablePortCallEditors);
        new QueryResultsRelationship(this.PersonProfilePageResponses, data.Notifications, r => r.Notifications);
        new QueryResultsRelationship(this.PersonProfilePageResponses, data.Roles,         r => r.Roles);
        // TH 10/03/2016: Need the defensive check on r.Ref && r.Ref.DefaultImages b/c the DataCache will also apply this lambda to the incoming Options object (in a non-typesafe way),
        // and we wanna allow that options object not to set the Ref property.
        new QueryResultsRelationship(this.PersonProfilePageResponses, data.DefaultImages, r => r.Ref && r.Ref.DefaultImages);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/personprofilepage/cache.ts